import * as React from 'react';
import { styled, ThemeProvider, useTheme } from '@mui/material/styles';
import Bs4Tooltip from '../../Bs4Components/Bs4Tooltip';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import ToggleButton from '@mui/material/ToggleButton';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import {getBs4Style} from '../../Bs4Components/Bs4Utils'

import Bs4Stores from '../../Bs4Stores'
import Bs4GenericField from './Bs4GenericField'
import Typography from '@mui/material/Typography';

export default class Bs4IconButSel extends Bs4GenericField {

  setValueBs4(valueOrg) {
    let value = valueOrg;
    if (Array.isArray(value)) value = value[0];
    if (typeof value === 'undefined') value = null;
    if (!Array.isArray(this.bs4Store)) this.bs4Store = [];
    if (this.bs4CardMainForObject) {
      value = this.bs4Store.find(item => item.id == value) || null;
      if (!value) {
        value = this.bs4Store[0] || null;
        // console.log('...Select...<><>', this.props?.field?.fieldLabel, '>',valueOrg, '<', value, this.bs4Store);
      }
    } else {
      this.bs4Store = Bs4Stores.addUnknownValuesToStore(this.bs4Store, [value]);
      value = this.bs4Store.find(item => item.id == value) || null;
    }
    this.setValue(value);
  }  

  setValue (value) {
    super.setValue(value || {id: '', name: ''})
  }

  getValueBs4 () {    
    return this.value?.id || '';
  }

  isDifferentValues (oldValue, newVaue) {
    return oldValue?.id != newVaue?.id;
  }

  isNativelyClearable () {
    return true;
  }

  getShortValue = () => {
    return this.getValue()?.name;
  }

  ViewComponentField = (props) => {
    const formField = this;    
    const [value, setValue] = React.useState(() => this.getValue());
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    const [bs4Store, setBs4Store] = React.useState(formField.bs4Store || []);
    this.refFocus = React.useRef();
    const theme = useTheme();

    React.useEffect(() => {
      this.notValidElementDom = (text) => {
        setError({error: true, helperText: text})
      }

      const CHANGE = (field, oldValue, newValue) => {
        setValue(this.getValue());
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      };
      this.on(Bs4GenericField.CHANGE, CHANGE);
      
      const CHANGE_STORE = (bs4Store) => {
        setBs4Store(bs4Store);
        this.setValueBs4(this.getValueBs4());
      };
      this.on(Bs4GenericField.CHANGE_STORE, CHANGE_STORE);

      return () => {
        this.off(CHANGE);
        this.off(CHANGE_STORE);
      }
    }, [error]);    

    const handleClick = (event) => {    
      let oldOption = value;
      let newOption = null;

      for (const option of bs4Store) {
        if (!oldOption) {
          newOption = option;
          break;
        }
        if (oldOption === option) oldOption = null;
      }
      if (!newOption) newOption = bs4Store[0];
      this.trigger(Bs4GenericField.FOCUS_ENTER, this);
      this.setValue(newOption);
      this.trigger(Bs4GenericField.FOCUS_LEAVE, this);
    }

    // if (value.style) {
    //   console.log('...StyleSSSSSSSSSS...', this.getLabelPlane(), value.style)
    // }

    if (value && !('bs4Style' in value)) value.bs4Style = getBs4Style(value.style, {});

    return (
      <FormControl fullWidth error={error.error}>
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <Box>
          <Bs4Tooltip
            arrow 
              title={
                <React.Fragment>
                  <Typography variant='body1' sx={{whiteSpace: 'pre-line'}}>{value?.name}</Typography>
                  <Typography variant='body2' sx={{whiteSpace: 'pre-line'}}>{value?.text}</Typography>          
                </React.Fragment>
              }
          >
            <Button
              ref={this.refFocus}
              value={value.id}
              sx={{
                padding: 1,
                minWidth: 0,
                ...value.bs4Style,
                '&:hover': {
                  ...value.bs4Style,
                },
              }}
              onClick={handleClick}              
            >            
              {value.icon ?
                <i className={value.icon} style={{fontSize: 16}}/>
              :
                <Typography variant='body1' sx={{whiteSpace: 'pre-line'}}>{value.name}</Typography>
              }
                              
            </Button>
          </Bs4Tooltip>
        </Box>
        <FormHelperText>{error.helperText}</FormHelperText>
      </FormControl>
    );
  }
}